/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { PURCHASE_ORDER_TYPES_OPTIONS } from 'domain/finance/purchaseOrder/usePurchaseOrderService';

const PurchaseOrderTypeField = (props: FieldProps) => {
  return <EnumField options={PURCHASE_ORDER_TYPES_OPTIONS} {...props} />;
};

export default PurchaseOrderTypeField;
